import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { STREAMS } from "../data/content";
import { Reveal } from "./Reveal";

export const StreamsShowcase = () => {
  const [active, setActive] = useState(0);
  const s = STREAMS[active];

  return (
    <section className="bg-gradient-to-b from-[#E7AEB4]/30 via-[#FAF4E9] to-[#FAF4E9] px-6 py-28" data-testid="streams-showcase">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="eyebrow text-[#C77E88]">Queen of Multiple Streams</p>
          <h2 className="font-serif-d text-4xl md:text-5xl text-[#1E3A2B] tracking-tight mt-3 max-w-2xl">
            One calling. <span className="italic-emph text-[#C77E88]">Many</span> assignments.
          </h2>
          <p className="text-[#21302A]/65 mt-4 max-w-lg">Tap a stream to step inside each part of the calling.</p>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-10 items-center mt-14">
          {/* Tabs + copy */}
          <div className="order-2 lg:order-1">
            <div className="flex flex-wrap gap-3">
              {STREAMS.map((st, i) => (
                <button key={st.id} data-testid={`stream-tab-${st.id}`} onClick={() => setActive(i)}
                  className={`px-6 py-3 uppercase tracking-widest text-xs font-medium transition-all duration-300 ${
                    active === i
                      ? "bg-[#1E3A2B] text-[#FAF4E9]"
                      : "bg-white border border-[#21302A]/15 text-[#21302A] hover:border-[#C77E88] hover:text-[#C77E88]"
                  }`}>
                  {st.label}
                </button>
              ))}
            </div>
            <AnimatePresence mode="wait">
              <motion.div key={s.id}
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4 }} className="mt-10">
                <p className={`eyebrow ${s.accent === "pink" ? "text-[#C77E88]" : "text-[#C0953A]"}`}>{s.tagline}</p>
                <p className="font-serif-d text-2xl md:text-3xl text-[#1E3A2B] leading-snug mt-4">{s.text}</p>
                <div className="flex gap-8 mt-8">
                  {STREAMS.map((st, i) => (
                    <button key={st.id} onClick={() => setActive(i)}
                      className={`font-serif-d text-3xl transition-colors ${active === i ? "text-[#C77E88]" : "text-[#21302A]/20 hover:text-[#21302A]/50"}`}>
                      0{i + 1}
                    </button>
                  ))}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <div className={`absolute -inset-3 -z-10 translate-x-4 translate-y-4 transition-colors duration-500 ${s.accent === "pink" ? "bg-[#C77E88]" : "bg-[#C0953A]"}`} />
            <AnimatePresence mode="wait">
              <motion.img key={s.id} src={s.image} alt={s.label}
                initial={{ opacity: 0, scale: 1.04 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }} className="w-full h-auto object-contain shadow-xl" />
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};
